import { getData, IDataAccessService } from '@price-for-profit/micro-services';
import { CLIENT_ID } from 'shared/constants';
import { Freight, FreightSql, MileageBucketParameters, RevisedMileageBucketNamedQueryParameters } from 'shared/types';

const FREIGHT = 'vw_customer_freight';
const MILEAGE_BUCKET_PROC = 'sp_update_mileage_bucket';

export interface UpdateMileageBucketProps extends MileageBucketParameters {}
export interface IFreightService {
  getGridData(): Promise<Freight[]>;
  updateMileageBucket(props: UpdateMileageBucketProps): Promise<Freight[]>;
}
function freightSqlToFreight({ hierarchy, ...sql }: FreightSql): Freight {
  return { ...sql, hierarchy: hierarchy.split(',') };
}
export class FreightService implements IFreightService {
  constructor(private dataAccessService: IDataAccessService) {}
  async updateMileageBucket({
    billToCustCode,
    mileageBucket,
    userEmail,
    userId,
  }: UpdateMileageBucketProps): Promise<Freight[]> {
    const { data } = await this.dataAccessService.executeNamedQuery<
      FreightSql,
      RevisedMileageBucketNamedQueryParameters,
      'main'
    >({
      clientId: CLIENT_ID,
      databaseLabel: 'main',
      queryName: MILEAGE_BUCKET_PROC,
      parameters: {
        MileageBucketParameters: [
          {
            billToCustCode,
            mileageBucket,
            userId,
            userEmail,
          },
        ],
      },
      partitionKey: '', // FIX This should be nullable.
    });

    return data.map(freightSqlToFreight);
  }

  async getGridData(): Promise<Freight[]> {
    const sql = await getData(page =>
      this.dataAccessService.getCollection<FreightSql, 'main'>({
        clientId: CLIENT_ID,
        databaseLabel: 'main',
        tableId: FREIGHT,
        pageSize: 1000,
        page,
      })
    );

    return sql.map(freightSqlToFreight);
  }
}
